'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Root() {
  const router = useRouter();
  useEffect(() => {
    const token = localStorage.getItem('se_token');
    const user  = localStorage.getItem('se_user');
    if (!token) {
      window.location.href = '/landing.html';
      return;
    }
    const u = user ? JSON.parse(user) : null;
    if (u?.role === 'super_admin') router.replace('/platform');
    else router.replace('/home');
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#080808', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 32, height: 32, border: '2px solid rgba(255,255,255,0.1)', borderTopColor: '#6366f1', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
